export const InvoiceOtherTags = ['invoice-other'];
